import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';

require('./osfruntime');
const osfCultureMapping = require('./osfCultureMapping');

OSF.getLocalizedStringsFilePath = function getOSFRuntimeStringsPath() {
    let basePath = getPackageBaseUrl() + 'resources/locale/osfruntime/';
    let language = !!getUserConfiguration().SessionSettings
        ? getUserConfiguration().SessionSettings.UserLanguage
        : 'en';
    let osfLanguageCode = osfCultureMapping[language];
    let languageCode = osfLanguageCode || 'en-us';
    let osfruntimeStringsPath = basePath + languageCode + '/jscript/';
    return osfruntimeStringsPath;
};

// TODO: Update this function not to throw for Outlook client in DevMain
OSF.getManifestHostType = function() {};
// TODO: Update this to be true for Outlook
OSF.AppTelemetry = { enableTelemetry: isFeatureEnabled('addin-oteljs') };
